module.exports = __webpack_public_path__ + "static/media/employees-commission.341ada37.svg";